import { installIosWebViewBridgeShim } from './common/lib/iosWebViewBridge';
import { installCryptoRandomUuidPolyfill } from './common/lib/cryptoRandomUuidPolyfill';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie9';
import React from 'react';
import ReactDOM from 'react-dom';
import { fromJS } from 'immutable';
import createHistory from 'history/createBrowserHistory';
import { syncHistoryWithStore } from 'react-router-redux';
import routes from './routes';
import Root from './Root';
import configureStore from './redux/configureStore';

let initialState = {};

installIosWebViewBridgeShim();
installCryptoRandomUuidPolyfill();

// rehydrate initialState for JS app
if (window.__INITIAL_STATE__) {
  initialState = window.__INITIAL_STATE__;

  // Transform into Immutable.js collections,
  // but leave top level keys untouched for Redux
  Object.keys(initialState).forEach((key) => {
    initialState[key] = fromJS(initialState[key]);
  });
}

const browserHistory = createHistory();

const store = configureStore(initialState, browserHistory);

const history = syncHistoryWithStore(browserHistory, store);

// Render the React application to the DOM
// Root component is to bootstrap Provider, Router and DevTools
ReactDOM.render(
  <Root history={history} routes={routes} store={store} />,
  document.getElementById('app-container'),
);
